export const ApiChat = {
    getChatCandidates: () => ({
        url: '/getChatCandidates',
        method: 'GET'
    }),
    getChatByUserId: (id, start = 0, limit = 3) => ({
        url: `/chats?userId=${id}&_sort=id:DESC&_start=${start}&_limit=${limit}`,
        method: 'GET'
    }),
    sendToCandidate: (userId, message) => ({
        url: '/sendToCandidate',
        method: 'POST',
        data: {
            userId,
            message
        }
    }),
    createChatByUsers: (user_ids, message) => ({
        url: '/createChatByUsers',
        method: 'POST',
        data: {
            user_ids,
            message
        }
    })
};